/* Happymami · Tienda — movimiento con el scroll (entrada y salida), igual que en la ficha del biberón.
   Anima la sección de la tienda y las que van debajo (matronas, reseñas, textos SEO, preguntas, cierre).
   Sin librerías. Respeta «Reducir movimiento» y no esconde nada en el editor del tema. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  if (reduced || editor || !('IntersectionObserver' in window)) return;
  var main = document.getElementById('MainContent');
  if (!main || !main.querySelector('.hm-tienda')) return;
  var small = window.matchMedia && window.matchMedia('(max-width: 899.98px)').matches;
  var HOLD = 400;
  var enterIO, exitIO;
  var all = [];

  // Cada bloque entra al asomar y sale al irse (por arriba o por abajo). Histéresis: la entrada y la salida usan franjas
  // distintas y un bloque no cambia de estado dos veces en menos de 400 ms (así no parpadea en el borde).
  // Al salir de la página (o ponerla en la caché de atrás/adelante) los observadores pueden dar «fuera de pantalla» para todo:
  // mientras dura, no se ocultan bloques; al volver se repasan.
  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('pageshow', function () { leaving = false; });
  function setState(el, inside, up) {
    if (leaving && !inside) return;
    var now = Date.now();
    if (el.__hmT && now - el.__hmT < HOLD) return;
    if (inside) {
      if (el.classList.contains('is-in')) return;
      el.__hmT = now;
      el.classList.remove('is-up', 'is-down');
      el.classList.add('is-in');
    } else {
      if (!el.classList.contains('is-in')) return;
      el.__hmT = now;
      el.classList.remove('is-in');
      el.classList.toggle('is-up', !!up);
      el.classList.toggle('is-down', !up);
    }
  }
  function build() {
    enterIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && (small || e.intersectionRatio >= 0.1)) {
          setState(e.target, true);
          (e.target.__fol || []).forEach(function (f) { setState(f, true); });
        }
      });
    }, { threshold: [0, 0.1], rootMargin: small ? '-6% 0px -10% 0px' : '0px 0px -8% 0px' });
    exitIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) setState(e.target, false, e.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: small ? '0% 0px -2% 0px' : '4% 0px 4% 0px' });
  }
  function reveal(el, kind, delay, leader) {
    if (!el || el.classList.contains('hm-rv')) return;
    el.classList.add('hm-rv');
    if (kind) el.classList.add('hm-rv--' + kind);
    if (delay) el.style.setProperty('--hm-d', delay + 'ms');
    if (leader && leader !== el) { (leader.__fol = leader.__fol || []).push(el); }
    all.push(el);
    enterIO.observe(el);
    exitIO.observe(el);
  }
  // list[0] lidera el grupo: los demás entran con él, escalonados.
  function stagger(list, kind, step, leader) {
    var arr = Array.prototype.slice.call(list);
    var lead = leader || arr[0];
    arr.forEach(function (el, i) { reveal(el, kind, Math.min(i, 6) * (step || 90), lead); });
  }

  // Red de seguridad: lo que ya se ve y sigue oculto aparece (con scroll rápido, mientras se mueve y con entrada corta).
  function sweepRun(fast, loose) {
    var vh = window.innerHeight || 800;
    all.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (seen > (loose ? 0 : r.height * (fast ? 0.15 : 0.35)) && r.top < vh * 0.99) {
        if (fast) {
          el.classList.add('hm-rv--fast');
          setTimeout(function () { el.classList.remove('hm-rv--fast'); }, 600);
        }
        setState(el, true);
      }
    });
  }

  function init() {
    build();
    var q = function (ctx, s) { return Array.prototype.slice.call((ctx || main).querySelectorAll(s)); };
    var tienda = main.querySelector('.hm-tienda');

    // Sección de la tienda
    stagger(q(tienda, '.hm-hero .in > *'), '', 80);
    reveal(q(tienda, '.hm-hero-img')[0], 's');
    q(tienda, '.hm-head').forEach(function (h) { reveal(h, ''); });
    reveal(q(tienda, '.hm-bib')[0], 's');
    stagger(q(tienda, '.hm-pack-grid .hm-card'), '', 100);
    stagger(q(tienda, '.hm-acc-grid .hm-acc'), 's', 90);
    reveal(q(tienda, '.hm-tet')[0], 's');

    // «No estás sola»
    q(main, '.hm-care').forEach(function (c) {
      stagger(q(c, '.hm-care-item'), 'l', 90);
    });

    // Matronas, reseñas, textos SEO, preguntas y cierre: lo que lleva el resto de la plantilla
    q(main, '.hm-ex').forEach(function (e) { reveal(e, 's'); });
    // Parte baja con el diseño de la tienda: reseñas, guía, preguntas y cierre
    q(main, '#opiniones').forEach(function (sec) {
      stagger(q(sec, '.hm-head').concat(q(sec, '.hm-revs-w'), q(sec, '.hm-revs-cta')), '', 110);
    });
    q(main, '.hm-guide').forEach(function (sec) {
      stagger(q(sec, '.hm-head').concat(q(sec, '.hm-det')), '', 90);
    });
    q(main, '.hm-faq').forEach(function (sec) {
      stagger(q(sec, '.hm-h2').concat(q(sec, '.hm-det'), q(sec, '.hm-note')), '', 80);
    });
    q(main, '.hm-close').forEach(function (c) { reveal(c, 's'); });
    q(main, '.rich-text').forEach(function (sec) {
      var blocks = q(sec, '.rich-text__blocks > *');
      if (blocks.length) stagger(blocks, '', 110);
    });
    q(main, '.collapsible-content').forEach(function (sec) {
      var head = q(sec, '.collapsible-content__heading')[0];
      var rows = q(sec, '.accordion');
      var list = (head ? [head] : []).concat(rows);
      if (list.length) stagger(list, '', 90);
    });

    // Scroll: barrido de seguridad (rápido mientras se mueve, normal al parar)
    var lastY = window.pageYOffset, lastT = performance.now(), lastFast = 0, sweepTimer = 0;
    window.addEventListener('scroll', function () {
      var now = performance.now(), y = window.pageYOffset;
      var speed = Math.abs(y - lastY) / Math.max(1, now - lastT);
      lastY = y; lastT = now;
      if (speed > 0.9 && now - lastFast > 60) { lastFast = now; sweepRun(true); }
      clearTimeout(sweepTimer);
      sweepTimer = setTimeout(function () { sweepRun(false); }, 320);
    }, { passive: true });
    // Primero se pone el estado «oculto» y, un instante después, entra lo que ya se ve: así la cabecera y la tarjeta del biberón
    // hacen su animación de entrada al cargar la página.
    document.documentElement.classList.add('hm-tm-js');
    var bib = q(tienda, '.hm-bib')[0];
    if (bib) bib.style.setProperty('--hm-d', '180ms');
    void document.body.offsetWidth;
    requestAnimationFrame(function () { requestAnimationFrame(function () { sweepRun(false); }); });
    setTimeout(function () { sweepRun(false); }, 500);

    // Volver desde otra página (atrás / adelante, con o sin caché de página): el navegador restaura el scroll después de cargar,
    // así que se repasa lo que ha quedado a la vista varias veces para que no se quede nada oculto.
    function resweep() {
      [0, 120, 350, 800, 1600].forEach(function (t) {
        setTimeout(function () { all.forEach(function (el) { el.__hmT = 0; }); sweepRun(false, true); }, t);
      });
    }
    window.addEventListener('pageshow', resweep);
    window.addEventListener('load', resweep);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) resweep(); });

    // Parallax suave de la cabecera
    var hero = q(tienda, '.hm-hero-img')[0], ticking = false;
    if (hero) {
      window.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          hero.style.setProperty('--py', (Math.min(window.pageYOffset, 600) * -0.12).toFixed(1) + 'px');
        });
      }, { passive: true });
    }

    // Al cambiar de filtro: lo que queda visible vuelve a entrar escalonado y la página sube a ello
    window.hmTiendaAfterFilter = function () {
      var shown = q(tienda, '[data-cat]').filter(function (c) { return !c.hidden; });
      var k = 0;
      shown.forEach(function (c) {
        q(c, '.hm-rv').forEach(function (el) {
          el.__hmT = 0;
          el.classList.remove('is-in', 'is-up', 'is-down');
          el.style.setProperty('--hm-d', Math.min(k++, 8) * 70 + 'ms');
        });
      });
      void tienda.offsetWidth;
      requestAnimationFrame(function () {
        shown.forEach(function (c) { q(c, '.hm-rv').forEach(function (el) { el.__hmT = 0; setState(el, true); }); });
      });
      var first = shown[0], bar = tienda.querySelector('.hm-filters');
      if (first && bar) {
        var chrome = document.querySelector('.hm-chrome');
        var off = (chrome ? chrome.getBoundingClientRect().bottom : 0) + bar.offsetHeight;
        var top = first.getBoundingClientRect().top + window.pageYOffset - off;
        if (window.pageYOffset > top - 40) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    };

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
